import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DrawerState } from '../../../core/models/enum';
import { OfficialFormInitialValues } from '../../../core/models/InitialValues';
import { FederationOfficialVm, OfficialDetailVm } from '../../../utils/api';
import { RouteParams } from '../../../core/models/RouteHelper';
import OfficialForm from './OfficialForm';

interface OwnProps {
    official?: OfficialDetailVm;
    federationOfficial?: FederationOfficialVm;
    initialValues?: OfficialFormInitialValues;
    handleClose: (drawerMode: DrawerState, id?: string) => void;
    refreshAfterSave: () => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(OfficialForm);
